import React from 'react';

/**
 * Rail: 272px left column of the Workspace. White, right border, scrolls on its
 * own. Content (LoanRail, DocumentRail, OrderRail + StepList) is supplied by the
 * Mode tasks; this is only the container.
 *
 * Requirement: 3.1.
 */
export interface RailProps {
  /** Accessible name, for example "Loans" or "Order steps". */
  label: string;
  children?: React.ReactNode;
  className?: string;
}

export const RAIL_WIDTH_PX = 272;

export const Rail: React.FC<RailProps> = ({ label, children, className = '' }) => (
  <aside
    aria-label={label}
    className={`w-[272px] shrink-0 overflow-y-auto border-r border-gray-200 bg-white ${className}`.trim()}
  >
    {children}
  </aside>
);

export interface RailItemProps {
  selected?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

/** Selectable Rail row: 3px left border #834DFB on #F5F3FF when selected. */
export const RailItem: React.FC<RailItemProps> = ({
  selected = false,
  onClick,
  children,
  className = '',
}) => (
  <button
    type="button"
    aria-current={selected ? 'true' : undefined}
    onClick={onClick}
    className={`block w-full border-l-[3px] px-4 py-3 text-left text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#834DFB] ${
      selected
        ? 'border-[#834DFB] bg-[#F5F3FF]'
        : 'border-transparent hover:bg-gray-50'
    } ${className}`.trim()}
  >
    {children}
  </button>
);

export default Rail;
